export class MPAOperationInfo {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "operation",
            "baseName": "operation",
            "type": "MPAOperationType",
            "format": ""
        },
        {
            "name": "scope",
            "baseName": "scope",
            "type": "MPAOperationScope",
            "format": ""
        },
        {
            "name": "product",
            "baseName": "product",
            "type": "MPAOperationProduct",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return MPAOperationInfo.attributeTypeMap;
    }
    constructor() {
    }
}
